module.exports = __webpack_public_path__ + "static/media/4.2a83df15.jpg";